/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useMemo } from 'react'

import { Box, WizardStep } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { DataCollectionCategories } from 'modules/processes/domain'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

import { useValidationsProvider } from '../../../Providers/validations'
import { WIZARD_TASK_TITLES } from '../../constants'
import type { WizardData } from '../../types'
import FillInformationHeader from './Header'
import { TaskComponent, useFillInformationComponents } from './useFillInformationComponents'

interface Props {
  data: WizardData
  onDataChanged: (newData: WizardData) => void
  setTitle: (title: string) => void
}

const FillInformation = ({ data, onDataChanged, setTitle }: Props) => {
  const { fieldWithErrors } = useValidationsProvider()
  const components = useFillInformationComponents()

  useEffect(() => {
    onDataChanged({ ...data, fieldWithErrors })
  }, [fieldWithErrors])

  useEffect(() => {
    setTitle(
      WIZARD_TASK_TITLES()[data.taskType as TaskConfigurationTypes & DataCollectionCategories]
    )

    onDataChanged({ ...data, currentStepIndex: 1 })
  }, [])

  const Component = useMemo(() => {
    return components[
      data.taskType as TaskConfigurationTypes & DataCollectionCategories
    ] as TaskComponent
  }, [data.taskType])

  return (
    <Box paddingRight="s12" paddingBottom="s24">
      <FillInformationHeader />
      <Box gap="s16" paddingTop="s24">
        <Component />
      </Box>
    </Box>
  )
}

export const fillInformationStep = (): WizardStep<WizardData> => ({
  title: i18n.t('processes.process_settings.wizard.tasks.fill_information.title'),
  nextText: i18n.t('common.next'),
  render: (props) => (
    <FillInformation
      data={props.data}
      onDataChanged={props.onDataChanged}
      setTitle={props.data.setTitle}
    />
  ),
  isCompleted: (data) => data.fieldWithErrors?.length === 0 && data.currentStepIndex >= 1,
})
